import Courses from "../Courses/Courses";
import React from "react";
import { baseUrl } from "../Api/Api";
import axios from "axios";

const sortFn = (a, b) => {
  let aP, bP;
  aP = a.position;
  bP = b.position;
  if (aP === bP) return 0;
  if (aP < bP) return -1;
  if (aP > bP) return 1;
  return 0;
};

const LpCollectionOfExamples = () => {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [courses, setCourses] = React.useState([]);

  React.useEffect(() => {
    const homepageUrl = baseUrl + "/homepage";
    const homepageRequest = axios.get(homepageUrl);
    setLoading(true);
    axios
      .all([homepageRequest])
      .then(
        axios.spread((...responses) => {
          setCourses(responses[0].data.courses);
          setLoading(false);
        })
      )
      .catch((errors) => {
        setError(errors);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <Courses
        courses={courses
          .filter((course) =>
            ["collectionOfExamples"].includes(course.courseType.code)
          )
          .sort(sortFn)}
      />
    </>
  );
};

export default LpCollectionOfExamples;
